import React, {Component} from 'react';
import {Container, Row} from "react-bootstrap";

class UicMenu extends Component {
    render() {
        return (
            <div className="footer-uic-menu">
                <div className="l-full flexer">

                    <div >
                        <div>
                            <Row>
                                <strong style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }}><a href="https://uic.edu/">UIC.edu</a></strong>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://catalog.uic.edu/ucat/academic-calendar/">Academic Calendar</a>

                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://uicflames.com/">Athletics</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://www.uic.edu/apps/departments-az/search">Campus Directory</a>

                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://disabilityresources.uic.edu/">Disability Resources</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://emergency.uic.edu/">Emergency Information</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://today.uic.edu/events">Event Calendar</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://uic.edu/about/job-opportunities">Job Openings</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://library.uic.edu/">Library</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://maps.uic.edu/">Maps</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://ready.uic.edu/digital-materials/uic-safe-mobile-app/">UIC Safe
                                    Mobile App</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://today.uic.edu/">UIC Today</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://uihealth.uic.edu/">UI Health</a>
                                <a style={{
                                    color: '#FFFFFF',
                                    margin: '5px 20px'
                                }} href="https://dos.uic.edu/student-veterans-affairs/">Veterans Affairs</a>
                            </Row>
                        </div>


                    </div>


                </div>
            </div>
        );
    }
}

export default UicMenu;


// WEBPACK FOOTER //
// ./src/components/footers/UIC-menu.js